const maybeFilterDates = (filterDates, allDates, firstDate) => filterDates
  ? (allDates || []).map(dateObj => {
    const filteredDateObj = { ...dateObj };
    filteredDateObj.times = dateObj.times.filter(({ asObject }) => asObject >= firstDate);

    return filteredDateObj.times.length ? filteredDateObj : null;
  }).filter(Boolean) : (allDates || []);

export default maybeFilterDates;